import React, { useState } from 'react'
import { FormLayout } from 'styles/FormLayout'
import { AcceptActionType, Config, CrateAction, InAssortmentActionType, isCommon, UNSET } from 'domain/Assortment'
import { SelectAction } from '../CommonComponents'

export type CrateActionSnapshotMultiselect = {
  acceptAction?: CrateAction
  inAssortmentAction?: CrateAction
}

export type DisabledCrateActionsMultiselect = {
  acceptAction: boolean
  inAssortmentAction: boolean
}

type Props = {
  config: Config
  id: string
  snapshot: CrateActionSnapshotMultiselect
  disabled: DisabledCrateActionsMultiselect
  onApply: (id: string, snapshot: CrateActionSnapshotMultiselect) => void
}

export const CrateActionDialogMultiselect = ({ config, id, snapshot, disabled, onApply }: Props) => {
  const [acceptAction, setAcceptedAction] = useState<CrateAction | undefined>(snapshot.acceptAction)
  const [inAssortmentAction, setInAssortmentAction] = useState<CrateAction | undefined>(snapshot.inAssortmentAction)

  return (
    <div className="card">
      <FormLayout.Content>
        <h3 className="text-lg mb-md">Active actions</h3>

        <SelectAction
          label={'ACCEPTED action:'}
          type={acceptAction?.type}
          disabled={disabled.acceptAction}
          showDisabled={isCommon(config)}
          allowOverride={acceptAction?.allowOverride}
          options={[AcceptActionType.SET, AcceptActionType.CLEAR, AcceptActionType.REMOVE]}
          onTypeChanged={(value) => {
            if (value === UNSET) {
              setAcceptedAction(undefined)
            } else {
              setAcceptedAction({ ...acceptAction, type: value as AcceptActionType })
            }
          }}
          onAllowOverrideChanged={(allow) => {
            if (acceptAction) {
              setAcceptedAction({ ...acceptAction, allowOverride: allow })
            }
          }}
        />

        <SelectAction
          label={'IN ASSORTMENT action:'}
          type={inAssortmentAction?.type}
          disabled={disabled.inAssortmentAction}
          showDisabled={isCommon(config)}
          allowOverride={inAssortmentAction?.allowOverride}
          options={[InAssortmentActionType.SET, InAssortmentActionType.CLEAR, InAssortmentActionType.REMOVE]}
          onTypeChanged={(value) => {
            if (value === UNSET) {
              setInAssortmentAction(undefined)
            } else {
              setInAssortmentAction({ ...inAssortmentAction, type: value as InAssortmentActionType })
            }
          }}
          onAllowOverrideChanged={(allow) => {
            if (inAssortmentAction) {
              setInAssortmentAction({ ...inAssortmentAction, allowOverride: allow })
            }
          }}
        />

        <FormLayout.FooterContainer>
          <FormLayout.Footer>
            <button
              className="btn btn-primary-dark py-sm"
              onClick={() => {
                onApply(id, {
                  acceptAction: acceptAction,
                  inAssortmentAction: inAssortmentAction,
                })
              }}
            >
              <span>Ok</span>
            </button>
          </FormLayout.Footer>
        </FormLayout.FooterContainer>
      </FormLayout.Content>
    </div>
  )
}
